"use strict";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.DataManager = void 0;
var _targeting = require("../targeting"),
  _dataProcessor = require("./dataProcessor"),
  _customData = require("./customData"),
  _types = require("./types"),
  _storage = require("../storage"),
  _clientConfiguration = require("../clientConfiguration"),
  _utilities = require("../utilities"),
  _conversion = require("./conversion"),
  _pageView = require("./pageView"),
  _browser = require("./browser"),
  _device = require("./device"),
  _geolocation = require("./geolocation"),
  _types2 = require("../types"),
  _operatingSystem = require("./operatingSystem"),
  _logging = require("../logging");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var DataManager = /*#__PURE__*/function () {
  function DataManager(a) {
    var _this = this;
    _classCallCheck(this, DataManager);
    var b = a.dataStorage,
      c = a.infoStorage,
      d = a.cleanupInterval,
      e = a.packageInfo;
    if (_defineProperty(this, "dataStorage", void 0), _defineProperty(this, "infoStorage", void 0), _defineProperty(this, "dataProcessor", void 0), _defineProperty(this, "targetingTrees", new Map()), _defineProperty(this, "mappingIdentifierCustomDataIndex", null), _defineProperty(this, "persistentCustomDataIndexes", new Set()), _defineProperty(this, "localCustomDataIndexes", new Set()), _defineProperty(this, "cleanupIntervalId", null), _defineProperty(this, "packageInfo", void 0), _logging.KameleoonLogger.debug(_templateObject || (_templateObject = _taggedTemplateLiteral(["CALL: new DataManager(dataStorage, infoStorage, cleanupInterval: ", ")"])), d), this.dataStorage = b, this.infoStorage = c, this.dataProcessor = new _dataProcessor.DataProcessor(d, e), this.packageInfo = e, d) {
      var _a = function _a() {
        _this.cleanupData();
      };
      try {
        this.cleanupIntervalId = setInterval(_a, d);
      } catch (a) {
        throw this.cleanupIntervalId && clearInterval(this.cleanupIntervalId), _logging.KameleoonLogger.error(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["Failed to set cleanup interval: ", ""])), d), a;
      }
    }
    _logging.KameleoonLogger.debug(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["RETURN: new DataManager(dataStorage, infoStorage, cleanupInterval: ", ")"])), d);
  }
  return _createClass(DataManager, [{
    key: "getUnsentData",
    value: function getUnsentData(a) {
      var _this2 = this;
      var b = this.infoStorage.read();
      if (!b.ok) return [];
      var c = b.data,
        d = this.getVisitorData(a);
      if (!c.unsentData[a] || !d) return [];
      var e = c.unsentData[a],
        f = c.nextVisitTime <= Date.now(),
        g = function g(a) {
          var b = a.status,
            c = a.key,
            d = a.cdIndex;
          return !!("number" == typeof d && _this2.persistentCustomDataIndexes.has(d) && f) || e.includes(c) && b === _types2.TrackingStatus.Unsent;
        };
      return f && (c.nextVisitTime = Date.now() + _storage.VISIT_DURATION, this.infoStorage.write(c)), this.getDataFromRaw(d, g);
    }
  }, {
    key: "getPendingData",
    value: function getPendingData(a) {
      var b = this.getVisitorData(a);
      if (!b) return [];
      return this.getDataFromRaw(b, function (a) {
        var b = a.status;
        return b === _types2.TrackingStatus.Pending;
      });
    }
  }, {
    key: "getDataFromRaw",
    value: function getDataFromRaw(a, b) {
      var c = [];
      for (var _i = 0, _Object$entries = Object.entries(a); _i < _Object$entries.length; _i++) {
        var _ref = _Object$entries[_i];
        var _ref2 = _slicedToArray(_ref, 2);
        var d = _ref2[0];
        var e = _ref2[1];
        if (e) switch (d) {
          case _types.KameleoonData.CustomData:
            {
              for (var _i2 = 0, _Object$values = Object.values(e); _i2 < _Object$values.length; _i2++) {
                var _a2 = _Object$values[_i2];
                if (!_a2) continue;
                var _e = _a2.status,
                  f = _a2.index;
                if (b({
                  status: _e,
                  key: d,
                  cdIndex: f
                })) {
                  var _b = _customData.CustomData._fromRaw(_a2);
                  c.push(_b);
                }
              }
              break;
            }
          case _types.KameleoonData.Conversion:
            {
              for (var _i3 = 0, _Object$values2 = Object.values(e); _i3 < _Object$values2.length; _i3++) {
                var _a3 = _Object$values2[_i3];
                if (_a3 && b({
                  status: _a3.status,
                  key: d
                })) {
                  var _b2 = _conversion.Conversion._fromRaw(_a3);
                  c.push(_b2);
                }
              }
              break;
            }
          case _types.KameleoonData.PageView:
            {
              for (var _i4 = 0, _Object$values3 = Object.values(e); _i4 < _Object$values3.length; _i4++) {
                var _a4 = _Object$values3[_i4];
                if (b({
                  status: _a4.status,
                  key: d
                })) {
                  var _b3 = _pageView.PageView._fromRaw(_a4);
                  c.push(_b3);
                }
              }
              break;
            }
          case _types.KameleoonData.GeolocationData:
            {
              var _a5 = e;
              if (!e) continue;
              if (b({
                status: _a5.status,
                key: d
              })) {
                var _b4 = _geolocation.GeolocationData._fromRaw(_a5);
                c.push(_b4);
              }
              break;
            }
          case _types.KameleoonData.Browser:
            {
              var _a6 = e;
              if (b({
                status: _a6.status,
                key: d
              })) {
                var _b5 = _browser.Browser._fromRaw(_a6);
                c.push(_b5);
              }
              break;
            }
          case _types.KameleoonData.Device:
            {
              var _a7 = e;
              if (b({
                status: _a7.status,
                key: d
              })) {
                var _b6 = _device.Device._fromRaw(_a7);
                c.push(_b6);
              }
              break;
            }
          case _types.KameleoonData.OperatingSystem:
            {
              var _a8 = e;
              if (b({
                status: _a8.status,
                key: d
              })) {
                var _b7 = _operatingSystem.OperatingSystem._fromRaw(_a8);
                c.push(_b7);
              }
            }
        }
      }
      return c;
    }
  }, {
    key: "storeTrackedData",
    value: function storeTrackedData(a) {
      var _this3 = this;
      this.storeData(a);
      var b = this.infoStorage.read();
      if (b.ok) {
        var c = b.data.unsentData;
        var _loop = function _loop() {
            var _ref3 = _Object$entries2[_i5];
            _ref4 = _slicedToArray(_ref3, 2);
            var b = _ref4[0];
            var d = _ref4[1];
            if (!c[b]) return {
              v: void 0
            };
            var a = new Set(c[b]);
            d.forEach(function (b) {
              var c = b.data;
              a.has(c.type) && a["delete"](c.type);
            });
            var e = d.some(function (a) {
              var b = a.data;
              if (b.type !== _types.KameleoonData.CustomData) return !1;
              var c = b.index;
              return _this3.persistentCustomDataIndexes.has(c) || _this3.mappingIdentifierCustomDataIndex === c;
            });
            e && a.add(_types.KameleoonData.CustomData), c[b] = Array.from(a), c[b].length || delete c[b];
          },
          _ref4,
          _ret;
        for (var _i5 = 0, _Object$entries2 = Object.entries(a); _i5 < _Object$entries2.length; _i5++) {
          _ret = _loop();
          if (_ret) return _ret.v;
        }
        this.infoStorage.write(b.data);
      }
    }
  }, {
    key: "storeData",
    value: function storeData(a) {
      for (var b = arguments.length, c = Array(1 < b ? b - 1 : 0), d = 1; d < b; d++) c[d - 1] = arguments[d];
      _logging.KameleoonLogger.debug(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["CALL: DataManager.storeData(visitorCode: ", ", data: ", ")"])), a, c);
      var e = this.dataStorage.read(),
        f = this.infoStorage.read();
      if (!e.ok) return e;
      if (!f.ok) return f;
      var g = e.data,
        h = f.data;
      if ("string" == typeof a) this.mutUpdateTargetingData({
        infoData: h,
        targetingData: g,
        visitorCode: a,
        kameleoonData: c
      });else for (var _i6 = 0, _Object$entries3 = Object.entries(a); _i6 < _Object$entries3.length; _i6++) {
        var _ref5 = _Object$entries3[_i6];
        var _ref6 = _slicedToArray(_ref5, 2);
        var _b8 = _ref6[0];
        var _c = _ref6[1];
        this.mutUpdateTargetingData({
          infoData: h,
          targetingData: g,
          visitorCode: _b8,
          kameleoonData: _c
        });
      }
      this.cleanupData(), this.infoStorage.write(f.data);
      var i = this.dataStorage.write(g);
      return _logging.KameleoonLogger.debug(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["RETURN: DataManager.storeData(visitorCode: ", ", data: ", ") -> (writeResult: ", ")"])), a, c, i), i;
    }
  }, {
    key: "getTree",
    value: function getTree(a) {
      if (this.targetingTrees.has(a.id)) return this.targetingTrees.get(a.id);
      var b = new _targeting.Tree(a);
      return this.targetingTrees.set(a.id, b), b;
    }
  }, {
    key: "clearTrees",
    value: function clearTrees() {
      this.targetingTrees.clear();
    }
  }, {
    key: "isPersistentCustomData",
    value: function isPersistentCustomData(a) {
      return !!this.persistentCustomDataIndexes.size && !!_utilities.Utilities.isCustomData(a) && this.persistentCustomDataIndexes.has(a.data.index);
    }
  }, {
    key: "isUniqueIdentifier",
    value: function isUniqueIdentifier(a) {
      var b;
      var c = this.getVisitorData(a),
        d = null === c || void 0 === c ? void 0 : c[_types.KameleoonData.UniqueIdentifier];
      return !(null === (b = null === d || void 0 === d ? void 0 : d.value) || void 0 === b) && b;
    }
  }, {
    key: "getVisitorIdentifier",
    value: function getVisitorIdentifier(a) {
      var b, c, d;
      var e = this.infoStorage.read();
      if (!e.ok) return a;
      var f = e.data;
      return null !== (b = f.mappingIdentifiers) && void 0 !== b ? b : f.mappingIdentifiers = {}, null !== (c = null === (d = f.mappingIdentifiers[a]) || void 0 === d ? void 0 : d.mappingIdentifier) && void 0 !== c ? c : a;
    }
  }, {
    key: "setMappingIdentifier",
    value: function setMappingIdentifier(a, b) {
      var c;
      var d = this.infoStorage.read();
      if (d.ok) {
        var e = d.data;
        null !== (c = e.mappingIdentifiers) && void 0 !== c ? c : e.mappingIdentifiers = {};
        var f = e.mappingIdentifiers[a];
        (!f || f.timestamp < b.timestamp) && (e.mappingIdentifiers[a] = b, this.infoStorage.write(e));
      }
    }
  }, {
    key: "getVisitorData",
    value: function getVisitorData(a) {
      this.cleanupData();
      var b = this.dataStorage.read();
      if (!b.ok) return;
      var _this$dataProcessor$d = this.dataProcessor.dereferenceData(b.data, a),
        c = _this$dataProcessor$d.visitorReference,
        d = _this$dataProcessor$d.data,
        e = _this$dataProcessor$d.isReference;
      if (this.packageInfo.isServer && e && !d[c]) {
        var _b9 = this.infoStorage.read();
        _b9.ok && _b9.data.mappingIdentifiers && delete _b9.data.mappingIdentifiers[a], delete d[a], c = a;
      }
      return d[c];
    }
  }, {
    key: "getVisitorStoredDataTypes",
    value: function getVisitorStoredDataTypes(a) {
      var b = this.getVisitorData(a);
      return b ? new Set(Object.keys(b)) : new Set();
    }
  }, {
    key: "getLinkedVisitor",
    value: function getLinkedVisitor(a) {
      var b = this.dataStorage.read();
      if (!b.ok) return null;
      if ("string" == typeof b.data[a]) return b.data[a];
      if (null === this.mappingIdentifierCustomDataIndex) return null;
      var c = b.data[a];
      if (!c) return null;
      var d = c[_types.KameleoonData.CustomData];
      return d && d[this.mappingIdentifierCustomDataIndex] ? d[this.mappingIdentifierCustomDataIndex].value[0] : null;
    }
  }, {
    key: "mutUpdateTargetingData",
    value: function mutUpdateTargetingData(a) {
      var b = a.infoData,
        c = a.visitorCode,
        d = a.kameleoonData,
        e = a.targetingData;
      var _iterator = _createForOfIteratorHelper(d),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var f = _step.value;
          f.data.type === _types.KameleoonData.CustomData && this.processCustomData({
            infoData: b,
            customData: f,
            mutData: e,
            visitorCode: c
          });
          var _a9 = this.dataProcessor.mutUpdateData({
              infoData: b,
              visitorCode: c,
              mutData: e,
              dataItem: f
            }),
            _d = b.nextDataCleanup;
          (!_d || _d && _a9 < _d) && (b.nextDataCleanup = _a9), f.data.status === _types2.TrackingStatus.Unsent && this.dataProcessor.mutAddUnsentData({
            mutData: b,
            visitorCode: c,
            dataType: f.data.type
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "cleanupData",
    value: function cleanupData() {
      var a = this.dataStorage.read(),
        b = this.infoStorage.read();
      if (!a.ok || !b.ok) return;
      var c = a.data,
        d = b.data,
        e = d.nextDataCleanup;
      if (e && e < Date.now()) {
        var _a10 = this.dataProcessor.mutCleanupData(c, d);
        d.nextDataCleanup = _a10 || void 0, this.infoStorage.write(d), this.dataStorage.write(c);
      }
    }
  }, {
    key: "processCustomData",
    value: function processCustomData(a) {
      var b = a.infoData,
        c = a.mutData,
        d = a.customData,
        e = a.visitorCode;
      var f = d.data,
        g = !!(f.value.length && f.value[0].length);
      if (this.mappingIdentifierCustomDataIndex === f.index && g) {
        d._isMappingIdentifier = !0;
        var _a11 = f.value[0];
        if (e !== _a11) {
          var h;
          _logging.KameleoonLogger.info(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["Linked anonymous visitor ", " with user ", ""])), e, _a11), this.dataProcessor.createReference({
            infoData: b,
            mutData: c,
            visitorCode: e,
            linkedVisitor: f.value[0]
          }), null !== (h = b.mappingIdentifiers) && void 0 !== h ? h : b.mappingIdentifiers = {}, b.mappingIdentifiers[_a11] = {
            mappingIdentifier: e,
            timestamp: Date.now()
          };
        }
      }
      this.localCustomDataIndexes.has(f.index) && (d.status = _types2.TrackingStatus.Sent);
    }
  }, {
    key: "unsentDataVisitors",
    get: function get() {
      var a = this.infoStorage.read();
      return a.ok ? Object.keys(a.data.unsentData) : [];
    }
  }, {
    key: "identifierCustomDataIndex",
    get: function get() {
      return this.mappingIdentifierCustomDataIndex;
    }
  }, {
    key: "trees",
    get: function get() {
      return this.targetingTrees;
    }
  }, {
    key: "storedCustomDataIndexes",
    get: function get() {
      var a = this.dataStorage.read();
      if (!a.ok) return new Set();
      var b = a.data;
      if (!(_types.KameleoonData.CustomData in b)) return new Set();
      var c = new Set();
      for (var _a12 in Object.keys(b[_types.KameleoonData.CustomData])) c.add(+_a12);
      return c;
    }
  }, {
    key: "customDataIndexes",
    set: function set(a) {
      var b;
      var c = [],
        d = [];
      a.forEach(function (a) {
        a.localOnly && c.push(a.index), a.scope === _clientConfiguration.CustomDataScope.Visitor && d.push(a.index);
      }), this.mappingIdentifierCustomDataIndex = (null === (b = a.find(function (a) {
        return a.isMappingIdentifier;
      })) || void 0 === b ? void 0 : b.index) || null, this.localCustomDataIndexes = new Set(c), this.persistentCustomDataIndexes = new Set(d);
    }
  }]);
}();
exports.DataManager = DataManager;